import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Ajouter au calendrier (iCal) — calendrier avec pastille plus duotone */
export const CalendarPlusIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Pastille + menthe en bas à droite */}
      <circle cx="17.5" cy="17.5" r="4.5" fill="var(--equiply-icon-bg)" />
      <path
        d="M17.5 15.5v4M15.5 17.5h4"
        stroke="hsl(var(--background))" strokeWidth="1.6" strokeLinecap="round"
      />
      {/* Calendrier */}
      <rect x="3" y="5" width="14" height="13" rx="2" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      <path d="M3 9.5h14" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M7 3v3.5M13 3v3.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
);
CalendarPlusIcon.displayName = "CalendarPlusIcon";
